module.exports = __webpack_public_path__ + "img/img1.ffa1d3a7.jpg";